/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useContext } from 'react';
import { AlertModalContext } from '../providers/AlertModals';

export type { AlertModalContentType } from '../providers/AlertModals';

export const useAlertModal = () => useContext(AlertModalContext);
